import { ShiftStage } from 'generated/graphql';

export const goodStages: ShiftStage[] = [
  ShiftStage.Accepted,
  ShiftStage.Finished,
  ShiftStage.Wasted,
  ShiftStage.Working,
];
